import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-add-setting-dialog',
    templateUrl: './add-setting-dialog.component.html',
    styleUrl: './add-setting-dialog.component.css',
    standalone: false,
})
export class AddSettingDialogComponent {
    constructor(private dialogRef: MatDialogRef<AddSettingDialogComponent>) {}

    addRows(numberRows: 1 | 2) {
        this.dialogRef.close(numberRows);
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
